import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteFilter } from '../../filter';
import { ClienteCadastroSituacaoChart } from '../cadastro-situacao';
import { ClienteSegmentoChart } from '../segmento';


@Injectable({
    providedIn: 'root'
})
export class ClienteChartHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiChart()}/cliente`
    }

    /** Carrega o gráfico de cadastros e situações dos clientes */
    loadCadastroSituacao(filter: ClienteFilter): Observable<ClienteCadastroSituacaoChart> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
            // Removendo cadastros
            params = params.delete('cadastro');
            // Removendo situações
            params = params.delete('situacao');
        }

        return this.customHttp.get<ClienteCadastroSituacaoChart>(`${this.pathApi}/cadastrosituacao`, {params});
    }

    /** Carrega o gráfico de segmentos dos clientes */
    loadSegmento(filter: ClienteFilter): Observable<ClienteSegmentoChart> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClienteSegmentoChart>(`${this.pathApi}/segmento`, {params});
    }
}
